module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	fox.registerWidget('AdvancedFilter', {

		configure: function () {

			this.registerOptions('', {
				autoRender: true,
				template: 'advancedFilter',
				'embed.container': '.filter-wrapper',
				handleDom: {
					toggle: {
						target: '.filter-title',
						event: 'click',
						callback: 'toggleFilter'
					},
					applyFilters: {
						target: '#set-filter',
						event: 'click',
						callback: 'apply'
					},
					reset: {
						target: '#reset-filter',
						event: 'click',
						callback: 'reset'
					},
					blur: {
						target: 'input[name]',
						event: 'blur',
						callback: '_handleBlur'
					}
				},
				handleWom: {
					controlSelectChange: {
						widget: '.Control_Select',
						event: 'change',
						callback: '_controlSelectChange'
					},

					controlDropdownChange: {
						widget: '.Control_DropdownMultipleSelect',
						event: 'change',
						callback: '_controlDropdownChange'
					},

					autoCompleteChange: {
						widget: '.Autocomplete2',
						event: 'search_form_submit',
						callback: '_autoCompleteChange'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {
			this.resetChanges();

			this.callParent('running', arguments);
		},

		toggleFilter: function (el) {
			var p = fox.dom.wrap(el).up();
			var isOpened = p.hasClass('expanded');

			//fox.dom[(isOpened ? 'removeClass' : 'addClass')]('expanded', p);
			p[(isOpened ? 'removeClass' : 'addClass')]('expanded');
		},

		collectData: function () {
			this.filters = {};

			fox.each(this.dom('input[name]'), function (input) {
				input = fox.dom.wrap(input);
				this.filters[input.attr('name')] = input.val();
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				this.filters[w.getAlias()] = w.getValue();
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				this.filters[w.getAlias()] = w.getValue();
			}, this);

			fox.each(this.wom('~.Control_DropdownMultipleSelect'), function (w) {
				this.filters[w.getAlias()] = w.getValue();
			}, this);

			// fox.each(this.wom('~.Autocomplete2_MultipleSelect'), function (w) {
			// 	this.filters[w.getAlias()] = w.getValue();
			// }, this);

			return this.filters;
		},

		apply: function () {
			this.collectData();
			this.dispatchEvent('apply', this.filters);

			//console.log('apply', this.filters);
		},

		reset: function () {
			this.filters = {};

			this.resetChanges();

			fox.each(this.dom('input[name]'), function (input) {
				input.value = '';
			}, this);

			fox.each(this.wom('~.Control_Select'), function (w) {
				w.reset();
			}, this);

			fox.each(this.wom('~.Autocomplete2'), function (w) {
				w.reset();
			}, this);

			fox.each(this.wom('~.Control_DropdownMultipleSelect'), function (w) {
				w.clear();
			}, this);

			this.dispatchEvent('reset');
		},

		setValue: function () {

			if (fox.isObject(arguments[0])) {
				fox.each(arguments[0], function (val, alias) {
					this._setValue(alias, val, (arguments[1] || {}));
				}, this);

				return;
			}

			
			if (fox.isString(arguments[0]) && !fox.isEmpty(arguments[1])) {
				this._setValue(arguments[0], arguments[1], (arguments[2] || {}));

				return;
			}

			
		},

		_setValue: function (alias, value, params) {
			var w = this.wom1('#' + alias);

			if (!w) {
				var input = this.dom1('input[name]');

				if (input) {
					input.value = value;
				}

				return;
			}

			if (fox.oop.instanceOf(w, 'Control_Select')) {
				w.setValue(value);

				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2_MultipleSelect')) {
				w.setValue(value, params);

				return;
			}

			if (fox.oop.instanceOf(w, 'Autocomplete2')) {
				w.fillInput(value);
				w.search(value);

				return;
			}

		},

		_handleBlur: function (el, alias, w, e) {
			if (fox.trim(el.value).length > 0) {
				this.addToChanges(el.name, el.value);

				return;
			}

			this.removeFromChanges(el.name);
		},

		_controlSelectChange: function (val, w) {
			var name = w.getAlias();

			if (val < 0 || val === '') {
				this.removeFromChanges(name);

				return;
			}

			this.addToChanges(name, val);
		},

		_controlDropdownChange: function (val, w, e) {
			var name = w.getAlias();

			if (val.length < 1) {
				this.removeFromChanges(name);

				return;
			}

			this.addToChanges(name, val);
		},

		_autoCompleteChange: function (obj, w, e) {
			var val = w.getValue();
			var name = w.getAlias();

			//console.log('_autoCompleteChange', name, val);

			if (!val) {
				this.removeFromChanges(name);

				return;
			}

			this.addToChanges(name, val);
		},

		addToChanges: function (name, value) {
			this.changes[name] = value;
			this.dispatchEvent('change', this.changes);
		},

		removeFromChanges: function (name) {
			delete this.changes[name];
			this.dispatchEvent('change', this.changes);
		},

		resetChanges: function () {
			this.changes = {};
		},

		getChangesNumber: function () {
			return fox.toArray(this.changes).length;
		}

	}, 'Widget');
})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/advancedFilter.js
// module id = 291
// module chunks = 2